/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".followup-btn[_ngcontent-%COMP%]{font-size:13px;border-radius:2px;line-height:16px;padding:2px 12px;background-color:#36924b;border-color:#36924b}"];
export { styles as styles };
